import { Dialog, DialogType } from '../../../../src/feature/narrator/narrator.model';

export const dialog: Dialog[] = [
  {
    id: 'start',
    type: DialogType.description,
    text: 'The miller looks up from the turning stone, flour white on his arms.',
    options: [
      { text: 'Greet him.', nextDialogId: 'greet' },
      { text: 'Ask about his mill.', nextDialogId: 'mill' },
    ],
  },
  {
    id: 'greet',
    type: DialogType.dialog,
    text: 'Good day to you. Flour, or just passing? The wheel turns either way.',
    options: [
      { text: 'Tell me of the mill.', nextDialogId: 'mill' },
      { text: 'Just passing.', nextDialogId: 'bye' },
    ],
  },
  {
    id: 'mill',
    type: DialogType.dialog,
    text: 'My father turned this wheel, and his before him. Good stone, good water from the Alzette. It never fails me.',
    options: [
      { text: 'Is the work hard?', nextDialogId: 'work' },
      { text: 'Fine work.', nextDialogId: 'bye' },
    ],
  },
  {
    id: 'work',
    type: DialogType.dialog,
    text: 'Hard enough. The stone must be dressed, the water watched, the grain kept dry. But bread does not make itself.',
    options: [{ text: 'True enough.', nextDialogId: 'bye' }],
  },
  {
    id: 'bye',
    type: DialogType.dialog,
    text: 'Take care, traveller. Mind the mud on the path.',
    options: [{ text: 'Leave.', nextDialogId: 'start' }],
  },
];
